import { isArray } from 'lodash-es'

// /////////////////////////////////////////////////////
// Riot mixin to validate all form fields efficiently //
// /////////////////////////////////////////////////////

// iterate over all tags with validations
// call validate, add to promise chain
// resolve reject chain
export default {
  validateForm(e) {
    const chain = []

    Object.keys(this.tags).forEach((key) => {
      if (isArray(this.tags[key])) {
        for (let i = this.tags[key].length - 1; i >= 0; i--) {
          if (this.tags[key][i].validate) {
            chain.push(this.tags[key][i].validate(e))
          }
        }
      }

      if (this.tags[key].validate) {
        chain.push(this.tags[key].validate(e))
      }

      if (this.tags[key].validateForm) {
        chain.push(this.tags[key].validateForm(e))
      }
    })

    return Promise.all(chain)
  },
}
